import { XplorButton } from '@xplor-education/react-wrappers'

export default XplorButton
